import {Outlet, Navigate, useLocation} from "react-router-dom";

export default function ProtectedRoute({isAllow, isAuthenticated, redirectPath = "/", children}) {
  const {pathname} = useLocation();

  if (!isAllow && !redirectPath.includes("http")) {
    return <Navigate to={redirectPath} state={{from: pathname}} replace />;
  }

  if (!isAllow) {
    return window.location.replace(redirectPath);
  }

  return <Outlet />;
}
